import { Injectable } from "@angular/core";
import { StateService } from "@core-services/state.service";
import { Observable } from "rxjs";

export interface AutoStakingTrackingState {
	overviewFlow: string;
}

const initialState: AutoStakingTrackingState = {
	overviewFlow: "deeplink"
};

@Injectable({ providedIn: "root" })
export class AutoStakingTrackingStateService extends StateService<AutoStakingTrackingState> {
	public constructor() {
		super(initialState);
	}

	public getState$(): Observable<AutoStakingTrackingState> {
		return this.select((state: AutoStakingTrackingState) => state);
	}

	public updateOverviewFlow(flow: string): void {
		this.setState({ overviewFlow: flow });
	}
}
